var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1179 5.49191C9.9229 5.5971 9.80133 5.79714 9.80133 6.01471V9.40258H3.11191C2.77414 9.40258 2.5 9.67036 2.5 10.0003C2.5 10.3302 2.77414 10.598 3.11191 10.598H9.80133V13.9859C9.80133 14.2043 9.9229 14.4043 10.1179 14.5087C10.3129 14.6147 10.5511 14.6075 10.7396 14.492L17.2144 10.5064C17.3923 10.3964 17.5 10.2059 17.5 10.0003C17.5 9.79469 17.3923 9.60422 17.2144 9.49424L10.7396 5.50864C10.6401 5.44807 10.5267 5.41699 10.4132 5.41699C10.3121 5.41699 10.2101 5.44249 10.1179 5.49191Z",
    fill: "#FDA800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow_right_icon.90cde1b8bf0523f40e718f315db52b6e.svg";
export { ForwardRef as ReactComponent };